"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    image: {
        width: '90%',
        height: 200,
    },
};
